import { toRem, toRems } from "../../helpers/theme";

const style = () => ({
    padding: toRems([20]),
    p: {
        padding: toRems([0, 20]),
        fontSize: toRem(20),
    },
    label: {
        flex: 0.5,
        textAlign: "left",
    },
});

export default style;
